// extracted by mini-css-extract-plugin
export default {"chartContainer":"VolumeLineChart_chartContainer__0shli","volumeInTitle":"VolumeLineChart_volumeInTitle__pex8j","volumeOutTitle":"VolumeLineChart_volumeOutTitle__YMrWR"};